import {getColors} from '../../utils/styles';

const colors = getColors();

export const HeartFilledIcon = ({color = colors.charcoal, className = '', ratio = 1}) => {
  // default dimensions
  const width = 32;
  const height = 32;

  // Use ratio to calculate width and height
  const style = {
    height: `${ratio * height}px`,
    width: `${ratio * width}px`,
  };

  const colorValue = (colors[color] as string) || color;

  return (
    <svg
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      style={style}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Filled Heart"
    >
      <path
        fill={colorValue}
        style={{fill: colorValue}}
        d="M16 6.033c3.123-2.737 7.95-2.646 10.96.296 3.007 2.944 3.11 7.632.313 10.69L15.997 28.041 4.724 17.019a7.655 7.655 0 0 1 .314-10.69C8.05 3.391 12.868 3.292 16 6.033"
      />
    </svg>
  );
};
